export default {
  props: {
    value: {
      type: String,
      required: false,
      default: true
    },
    maxChars: {
      type: Number,
      default: 5
    }
  },
  methods: {
    reset () {
      this.customMessage = ''
    },
    submit () {
      this.$emit('submit')
    },
    normalizeSymbol (symbol) {
      if (symbol === ' ') {
        return '&nbsp;'
      }

      return symbol
    },
    keyPress (symbol) {
      switch (symbol) {
        case 'del':
          this.customMessage = this.customMessage.substring(0, this.customMessage.length - 1)
          break

        case 'return':
          this.submit()
          break

        default:
          this.customMessage += symbol
      }
    }
  },
  data () {
    return {
      customMessage: '',
      initDone: false
    }
  },
  watch: {
    customMessage (value) {
      if (value.length > this.maxChars) {
        this.customMessage = value.substring(0, this.maxChars)
      }

      if (this.initDone) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    this.customMessage = this.value
    this.initDone = true
  }
}
